import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2, Smartphone, FileText, ShieldCheck } from "lucide-react";

export default function Hero() {
  return (
    <section id="accueil" className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top_right,rgba(31,122,99,0.10),transparent_55%)]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-16 lg:pt-20 pb-16 lg:pb-24 grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
        <div className="lg:col-span-6 ek-rise">
          <div className="inline-flex items-center gap-2 bg-[#E8F2EF] text-[#1F7A63] px-3 py-1.5 rounded-full text-xs font-semibold">
            <span className="w-2 h-2 rounded-full bg-[#E6B800]" /> Conçu pour les écoles du Sénégal
          </div>
          <h1 className="mt-5 text-4xl sm:text-5xl lg:text-[3.2rem] font-bold tracking-tight leading-[1.08]" style={{ fontFamily: "Outfit" }} data-testid="hero-title">
            EDUKATI — <span className="text-[#1F7A63]">La gestion scolaire intelligente,</span> simple et accessible.
          </h1>
          <p className="mt-5 text-base sm:text-lg text-[#5C736A] leading-relaxed">
            Gérez vos élèves, vos classes, vos examens, vos bulletins, les présences, les performances et les finances de votre établissement depuis une seule plateforme.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row sm:flex-wrap gap-3">
            <Link to="/inscription" data-testid="hero-cta-start">
              <Button className="w-full sm:w-auto h-12 px-7 text-base bg-[#1F7A63] hover:bg-[#165c4b] text-white font-semibold shadow-lg shadow-[#1F7A63]/20">
                Commencer maintenant <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
            <a href="#fonctionnalites" data-testid="hero-cta-features">
              <Button variant="outline" className="w-full sm:w-auto h-12 px-7 text-base border-[#1F7A63]/30 text-[#1F7A63] hover:bg-[#E8F2EF] font-semibold">
                Découvrir les fonctionnalités
              </Button>
            </a>
          </div>
          <ul className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm text-[#1A2E28]">
            {[[Smartphone, "Pensé pour le téléphone"], [FileText, "Bulletins PDF"], [ShieldCheck, "Comptes validés"]].map(([Icon, t]) => (
              <li key={t} className="flex items-center gap-2"><Icon className="w-4 h-4 text-[#1F7A63]" /> {t}</li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-6 ek-rise" style={{ animationDelay: "120ms" }}>
          <div className="relative">
            <div className="absolute -inset-4 sm:-inset-6 bg-[#E6B800]/20 rounded-[2rem] rotate-[-2deg]" />
            <figure className="relative rounded-2xl overflow-hidden border border-[#1A2E28]/10 bg-white shadow-2xl shadow-[#1A2E28]/15">
              <div className="h-8 bg-[#F6F8F9] border-b border-[#E2E8F0] flex items-center gap-1.5 px-3">
                <span className="w-2.5 h-2.5 rounded-full bg-[#E2E8F0]" /><span className="w-2.5 h-2.5 rounded-full bg-[#E2E8F0]" /><span className="w-2.5 h-2.5 rounded-full bg-[#E2E8F0]" />
                <span className="ml-3 text-[10px] text-[#5C736A] truncate">Tableau de bord EDUKATI</span>
              </div>
              <img src="/screens/dashboard.jpg" alt="Capture du tableau de bord EDUKATI" className="w-full h-auto block" loading="eager" data-testid="hero-screenshot" />
            </figure>
            <div className="hidden sm:flex absolute -bottom-5 -left-5 bg-white rounded-xl shadow-xl border border-[#E2E8F0] px-4 py-3 items-center gap-3">
              <CheckCircle2 className="w-6 h-6 text-[#1F7A63]" />
              <div><div className="text-xs text-[#5C736A]">Capture réelle</div><div className="text-sm font-semibold">de l&apos;application</div></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
